/**
 * @title: 策略相关url
 * @fileName: index
 * @projectName WEB
 * @author ：yaaynn
 * @date ：2020/6/28 15:09
 * @modified By：
 * @version:     1.0$
 * @description: TODO
 */
import Ppm from './modules/ppm'
class Decision{
    constructor(hostname, path = '/api') {
        this._ppm = new Ppm(hostname, path)
    }
    get ppm (){
        return this._ppm
    }
}
export default Decision
